// Module
var code = "<script id=\"wcc-components-attachment-controls-progress\" type=\"text/template\">\r\n    <progress-ring params=\"value: progress, size: size, strokeWidth: strokeWidth, color: color\">\r\n        <span data-bind=\"css: icon\"></span>\r\n    </progress-ring>\r\n</script>";
// Exports
module.exports = code;